"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _AccordionSummaryStyle = _interopRequireDefault(require("./AccordionSummaryStyle"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Summary = (0, _core.withStyles)({
  root: {
    marginBottom: -1,
    minHeight: 48,
    paddingLeft: 14,
    paddingRight: 14,
    paddingTop: 6,
    '&$expanded': {
      minHeight: 48
    }
  },
  content: {
    '&$expanded': {
      margin: '4px 0px 15px 0px'
    }
  },
  expanded: {}
})(_core.AccordionSummary);
var CustomAccordionSummary = function CustomAccordionSummary(_ref) {
  var children = _ref.children,
    classes = _ref.classes;
  return /*#__PURE__*/_react.default.createElement(Summary, {
    expandIcon: /*#__PURE__*/_react.default.createElement(_icons.ExpandMore, {
      classes: {
        root: classes.dropDownIconSubSection
      },
      style: {
        fontSize: 26
      }
    }),
    classes: {
      expandIcon: classes.ExpansionPaneldropDownIcon
    }
  }, children);
};
var _default = (0, _core.withStyles)(_AccordionSummaryStyle.default)(CustomAccordionSummary);
exports.default = _default;